// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import fastClick from 'fastclick'
import http from './utils/http'
import './utils/axios'
import api from './utils/api'
import store from 'good-storage'
import VueCookies from 'vue-cookies'
import VueCropper from 'vue-cropper'
import AMap from 'vue-amap'
import vxStore from './vuex/vxStore'
import moment from 'moment'

import htmlToPdf from './utils/htmlToPdf'
// 使用Vue.use()方法就会调用工具方法中的install方法

Vue.use(htmlToPdf)
Vue.use(ElementUI)
Vue.use(VueCookies)
Vue.use(VueCropper)
Vue.use(AMap)
Vue.config.productionTip = false
fastClick.attach(document.body)
Vue.filter('dateFormat', (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') => {
  return moment(dataStr).format(pattern)
})

Vue.filter('dateFormat1', (dataStr, pattern = 'YYYY.MM.DD') => {
  return moment(dataStr).format(pattern)
})

// api配置接口url
Vue.prototype.$api = api
// http封装了axios
Vue.prototype.$http = http
// store用于缓存数据
Vue.prototype.$store = store
// Vuex
Vue.prototype.$vxStore = vxStore

// 初始化vue-amap
// noinspection JSUnresolvedFunction
AMap.initAMapApiLoader({
  // 高德key
  key: '14fdfb687668c6e14e609a84ee518aa6',
  // 插件集合 （插件按需引入）
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
  v: '1.4.4',
  uiVersion: '1.0'
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js